import React from "react";
import { MoonLoader } from "react-spinners";
import { useDarkMode } from "../context/darkModeContext";
import "../css/LoadingScreen.css";

const LoadingScreen: React.FC = () => {
  const { darkMode } = useDarkMode();
  return (
    <div className={darkMode ? "loading-screen--dark" : "loading-screen"}>
      <MoonLoader
        size={36}
        color={darkMode ? "hsl(0, 0%, 59%)" : "rgb(89, 8, 238)"}
      />
    </div>
  );
};

export default LoadingScreen;
